import React, { useEffect, useState, useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { useAppStore } from '../context/AppStore';
import { Button, Badge, NetworkIcon, Card } from '../components/ui';
import { postsAPI, bulkPublishAPI, captionTemplatesAPI } from '../api/client';
import { NETWORK_CONFIG } from '../api/mockData';
import toast from 'react-hot-toast';

const TONES = [
  { id: 'profesional', label: '💼 Profesional' },
  { id: 'casual',      label: '😊 Casual' },
  { id: 'inspiracional', label: '✨ Inspiracional' },
  { id: 'humoristico', label: '😂 Humorístico' },
];

function BulkItem({ item, index, accounts, projects, onChange, onRemove }) {
  const nets = accounts.filter(a => a.is_connected);

  const toggleNetwork = (acc) => {
    const exists = item.networks.find(n => n.account_id === acc.id);
    if (exists) {
      onChange({ ...item, networks: item.networks.filter(n => n.account_id !== acc.id) });
    } else {
      onChange({ ...item, networks: [...item.networks, { account_id: acc.id, network: acc.network, caption: item.caption, hashtags: item.hashtags }] });
    }
  };

  return (
    <div style={{ padding: '16px', background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 'var(--radius-lg)' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '14px' }}>
        <span style={{ fontFamily: 'var(--font-display)', fontWeight: '700', fontSize: '14px' }}>Configuración #{index + 1}</span>
        <button onClick={onRemove} style={{ background: '#ef444415', border: '1px solid #ef444430', color: '#ef4444', cursor: 'pointer', padding: '4px 8px', borderRadius: '6px', fontSize: '12px' }}>✕ Eliminar</button>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        {/* Proyecto */}
        <div>
          <label style={{ fontSize: '12px', fontWeight: '600', color: 'var(--text-secondary)', display: 'block', marginBottom: '4px' }}>Proyecto</label>
          <select value={item.project_id || ''} onChange={e => onChange({ ...item, project_id: e.target.value || null })}
            style={{ width: '100%', padding: '8px 10px', borderRadius: 'var(--radius-md)', background: 'var(--bg-elevated)', border: '1px solid var(--border)', color: 'var(--text-primary)', fontSize: '13px', fontFamily: 'var(--font-body)', outline: 'none' }}>
            <option value="">Sin proyecto</option>
            {projects.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
          </select>
        </div>

        {/* Tono */}
        <div>
          <label style={{ fontSize: '12px', fontWeight: '600', color: 'var(--text-secondary)', display: 'block', marginBottom: '4px' }}>Tono</label>
          <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
            {TONES.map(t => (
              <button key={t.id} onClick={() => onChange({ ...item, tone: t.id })} style={{ padding: '5px 10px', borderRadius: '7px', border: `1px solid ${item.tone === t.id ? '#7c3aed' : 'var(--border)'}`, background: item.tone === t.id ? '#7c3aed20' : 'var(--bg-elevated)', color: item.tone === t.id ? '#a78bfa' : 'var(--text-muted)', fontSize: '12px', fontFamily: 'var(--font-body)', cursor: 'pointer' }}>{t.label}</button>
            ))}
          </div>
        </div>

        {/* Redes */}
        <div>
          <label style={{ fontSize: '12px', fontWeight: '600', color: 'var(--text-secondary)', display: 'block', marginBottom: '6px' }}>Redes sociales</label>
          <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
            {nets.map(acc => {
              const sel = !!item.networks.find(n => n.account_id === acc.id);
              return (
                <button key={acc.id} onClick={() => toggleNetwork(acc)} style={{ display: 'flex', alignItems: 'center', gap: '6px', padding: '6px 10px', borderRadius: '8px', border: `1px solid ${sel ? (NETWORK_CONFIG[acc.network]?.color || '#7c3aed') : 'var(--border)'}`, background: sel ? `${NETWORK_CONFIG[acc.network]?.color || '#7c3aed'}20` : 'var(--bg-elevated)', cursor: 'pointer' }}>
                  <NetworkIcon network={acc.network} size={16} />
                  <span style={{ fontSize: '12px', color: sel ? 'var(--text-primary)' : 'var(--text-muted)' }}>{acc.name}</span>
                </button>
              );
            })}
          </div>
        </div>

        {/* Caption */}
        <div>
          <label style={{ fontSize: '12px', fontWeight: '600', color: 'var(--text-secondary)', display: 'block', marginBottom: '4px' }}>Caption (se aplica a todas las redes seleccionadas)</label>
          <textarea value={item.caption} onChange={e => onChange({ ...item, caption: e.target.value, networks: item.networks.map(n => ({ ...n, caption: e.target.value })) })} rows={3}
            style={{ width: '100%', padding: '8px 10px', borderRadius: 'var(--radius-md)', background: 'var(--bg-elevated)', border: '1px solid var(--border)', color: 'var(--text-primary)', fontSize: '13px', fontFamily: 'var(--font-body)', outline: 'none', resize: 'vertical', boxSizing: 'border-box' }} />
        </div>

        {/* Hashtags */}
        <div>
          <label style={{ fontSize: '12px', fontWeight: '600', color: 'var(--text-secondary)', display: 'block', marginBottom: '4px' }}>Hashtags</label>
          <input value={item.hashtags} onChange={e => onChange({ ...item, hashtags: e.target.value, networks: item.networks.map(n => ({ ...n, hashtags: e.target.value })) })}
            placeholder="#tag1 #tag2"
            style={{ width: '100%', padding: '8px 10px', borderRadius: 'var(--radius-md)', background: 'var(--bg-elevated)', border: '1px solid var(--border)', color: 'var(--text-primary)', fontSize: '13px', fontFamily: 'var(--font-body)', outline: 'none', boxSizing: 'border-box' }} />
        </div>

        {/* Programar */}
        <div>
          <label style={{ fontSize: '12px', fontWeight: '600', color: 'var(--text-secondary)', display: 'block', marginBottom: '4px' }}>📅 Programar (opcional)</label>
          <input type="datetime-local" value={item.scheduled_at || ''} min={new Date(Date.now() + 60000).toISOString().slice(0, 16)}
            onChange={e => onChange({ ...item, scheduled_at: e.target.value || null })}
            style={{ padding: '8px 10px', borderRadius: 'var(--radius-md)', background: 'var(--bg-elevated)', border: '1px solid var(--border)', color: 'var(--text-primary)', fontSize: '13px', fontFamily: 'var(--font-body)', outline: 'none', colorScheme: 'dark' }} />
        </div>
      </div>
    </div>
  );
}

function newItem() {
  return { project_id: null, networks: [], tone: 'profesional', caption: '', hashtags: '', scheduled_at: null };
}

export default function BulkPublishPage() {
  const { accounts, fetchAccounts, projects, fetchProjects } = useAppStore();
  const [file, setFile]       = useState(null);
  const [preview, setPreview] = useState(null);
  const [mediaId, setMediaId] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [items, setItems]     = useState([newItem()]);
  const [publishing, setPublishing] = useState(false);
  const [results, setResults] = useState(null);

  useEffect(() => { fetchAccounts(); fetchProjects(); }, []);

  const onDrop = useCallback(async (accepted) => {
    if (!accepted[0]) return;
    const f = accepted[0];
    setFile(f);
    setPreview(URL.createObjectURL(f));
    setMediaId(null);
    setUploading(true);
    try {
      const fd = new FormData(); fd.append('file', f);
      const { data } = await postsAPI.upload(fd);
      setMediaId(data.media_id);
      toast.success(`Archivo subido: ${data.size_mb.toFixed(1)} MB`);
    } catch { toast.error('Error al subir el archivo'); }
    setUploading(false);
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop, accept: { 'image/*': [], 'video/*': [] }, maxSize: 500 * 1024 * 1024, multiple: false,
  });

  const handlePublish = async () => {
    if (!mediaId) { toast.error('Sube un archivo primero'); return; }
    const valid = items.filter(i => i.networks.length > 0);
    if (valid.length === 0) { toast.error('Configura al menos una red en alguna configuración'); return; }
    setPublishing(true);
    try {
      const payload = {
        media_id: mediaId,
        items: valid.map(i => ({
          project_id: i.project_id || null,
          networks: i.networks,
          tone: i.tone,
          scheduled_at: i.scheduled_at ? new Date(i.scheduled_at).toISOString() : null,
        })),
      };
      const { data } = await bulkPublishAPI.publish(payload);
      setResults(data);
      toast.success(`Publicación masiva: ${data.success}/${data.total} exitosas`);
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'Error en la publicación masiva');
    }
    setPublishing(false);
  };

  if (results) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', maxWidth: '680px' }}>
        <div style={{ textAlign: 'center', padding: '20px 0' }}>
          <div style={{ fontSize: '56px', marginBottom: '12px' }}>🎉</div>
          <h2 style={{ fontFamily: 'var(--font-display)', fontSize: '22px', fontWeight: '800' }}>Publicación masiva completada</h2>
          <p style={{ color: 'var(--text-muted)', marginTop: '6px' }}>{results.success} de {results.total} configuraciones procesadas correctamente</p>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          {results.results.map((r, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '12px 16px', borderRadius: 'var(--radius-md)', background: 'var(--bg-elevated)', border: `1px solid ${r.error ? '#ef444430' : '#10b98130'}` }}>
              <span style={{ fontSize: '18px' }}>{r.error ? '✕' : '✓'}</span>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: '13px', fontWeight: '600' }}>Configuración #{i + 1}</div>
                <div style={{ fontSize: '11px', color: 'var(--text-muted)' }}>{r.error || `Status: ${r.status}`}</div>
              </div>
              <Badge color={r.error ? '#ef4444' : '#10b981'}>{r.error ? 'Error' : r.status}</Badge>
            </div>
          ))}
        </div>
        <div style={{ display: 'flex', gap: '10px' }}>
          <Button onClick={() => { setResults(null); setFile(null); setPreview(null); setMediaId(null); setItems([newItem()]); }} variant="secondary" style={{ flex: 1 }}>Nueva publicación masiva</Button>
          <Button onClick={() => window.location.href = '/posts'} style={{ flex: 1 }}>Ver publicaciones →</Button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', maxWidth: '760px' }}>
      <div>
        <p style={{ color: 'var(--text-muted)', fontSize: '14px' }}>
          Sube un archivo y publícalo en múltiples proyectos y redes con diferentes captions en una sola operación.
        </p>
      </div>

      {/* Upload */}
      <Card>
        <h3 style={{ fontFamily: 'var(--font-display)', fontWeight: '700', fontSize: '15px', marginBottom: '14px' }}>1. Archivo a publicar</h3>
        <div {...getRootProps()} style={{ border: `2px dashed ${isDragActive ? '#7c3aed' : file ? '#10b981' : 'var(--border)'}`, borderRadius: 'var(--radius-xl)', padding: '32px', textAlign: 'center', cursor: 'pointer', transition: 'all 0.3s', background: isDragActive ? '#7c3aed10' : file ? '#10b98110' : 'var(--bg-elevated)' }}>
          <input {...getInputProps()} />
          {file ? (
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px' }}>
              {file.type.startsWith('video')
                ? <video src={preview} style={{ maxHeight: '160px', borderRadius: 'var(--radius-lg)' }} muted />
                : <img src={preview} alt="preview" style={{ maxHeight: '160px', borderRadius: 'var(--radius-lg)', objectFit: 'contain' }} />
              }
              <Badge color={uploading ? '#f59e0b' : mediaId ? '#10b981' : '#ef4444'}>
                {uploading ? '⏳ Subiendo...' : mediaId ? '✓ Listo' : '✕ Error'}
              </Badge>
              <span style={{ fontSize: '13px', color: 'var(--text-muted)' }}>{file.name}</span>
            </div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px' }}>
              <span style={{ fontSize: '40px' }}>📤</span>
              <span style={{ fontSize: '14px', color: 'var(--text-muted)' }}>Arrastra o haz clic para seleccionar</span>
            </div>
          )}
        </div>
      </Card>

      {/* Configuraciones */}
      <Card>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' }}>
          <h3 style={{ fontFamily: 'var(--font-display)', fontWeight: '700', fontSize: '15px' }}>2. Configuraciones de publicación</h3>
          <Button size="sm" icon="+" onClick={() => setItems(i => [...i, newItem()])}>Agregar</Button>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          {items.map((item, i) => (
            <BulkItem
              key={i} index={i} item={item}
              accounts={accounts} projects={projects}
              onChange={updated => setItems(items.map((x, j) => j === i ? updated : x))}
              onRemove={() => setItems(items.filter((_, j) => j !== i))}
            />
          ))}
        </div>
      </Card>

      {/* Resumen */}
      <div style={{ padding: '14px 16px', background: 'var(--bg-elevated)', borderRadius: 'var(--radius-lg)', border: '1px solid var(--border)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '12px' }}>
        <div style={{ fontSize: '13px', color: 'var(--text-secondary)' }}>
          <strong>{items.reduce((a, i) => a + i.networks.length, 0)}</strong> publicaciones en{' '}
          <strong>{items.filter(i => i.networks.length > 0).length}</strong> configuraciones
        </div>
        <Button
          size="lg" icon="🚀"
          loading={publishing}
          disabled={!mediaId || uploading}
          onClick={handlePublish}
        >
          {publishing ? 'Publicando...' : 'Publicar todo'}
        </Button>
      </div>
    </div>
  );
}
